import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../../main/main.styles';
import REsuretyLogo from '../../../../../assets/REsurety-logo.svg';
import { mixinRobotoBold, mixinRobotoMedium, mixinRobotoRegular } from '../../../../../styles';
import Gradient from '../../../../../assets/gradient.png';

export const MetricTileStyles = css`
  ${MainStyles}

  :host {
    display: contents;
  }

  .tile {
    width: 100%;
    position: relative;
    margin-top: 5px;
    padding: 12px 10px;
    background: var(--card-header-bg);
    border: 1px solid var(--border-1);
  }

  .tile-header {
    padding-top: 6px;
    font-size: 12px;
    color: #bcbcbe;
  }

  .tile .tile-content {
    font-size: 18px;
    color: var(--white);
    display: flex;
    justify-content: space-between;
  }

  .vppa-value .header,
  .all-vppa-average .header {
    color: var(--gray-lighter);
    font-size: 12px;
    font-weight: 700;
    padding-bottom: 10px;
    ${mixinRobotoBold};
  }

  .vppa-value .value {
    color: var(--primary-color);
    font-size: 18px;
    ${mixinRobotoMedium()};
  }

  .all-vppa-average .value {
    color: var(--white);
    font-size: 18px;
    ${mixinRobotoMedium()};
  }

  .all-vppa-average .value {
    text-align: right;
  }

  .vppa-ranking {
    background: url(${Gradient}) no-repeat;
    background-size: contain;
    background-position: bottom center;
    width: 38%;
    position: relative;
  }

  .vppa-ranking .value {
    position: absolute;
    top: 0;
    transform: translate(-50%, 0);
    text-align: center;
    font-size: 12px;
  }

  .vppa-ranking .value::after {
    content: '';
    width: 0;
    height: 0;
    display: block;
    position: relative;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-top: 10px solid white;
    margin-top: 2px;
  }

  .footer {
    position: absolute;
    display: flex;
    gap: 5px;
    bottom: 10px;
    right: 0;
    font-size: 11px;
    ${mixinRobotoRegular}
  }

  .resurety-logo {
    background: url(${REsuretyLogo}) no-repeat;
    background-size: contain;
    width: 75px;
    height: 20px;
    display: inline-block;
  }
`;
